<img [id]="mediaId" [ngClass]="mediaClass" [src]="imageSrc" *ngIf="imageSrc && !isVideo()" alt="" />

<video
  autoplay
  [id]="mediaId"
  [ngClass]="mediaClass"
  [src]="videoSrc"
  *ngIf="videoSrc && isVideo()"
  controls
  controlsList="nodownload"
></video>
